import React from 'react';
import { compose } from 'redux';
import { withContent } from 'components/Content';
import Gulch from 'components/Gulch';
import Hero from 'components/Hero';
import DeliveryFlow from 'components/DeliveryFlow';
import PromoBanner, { CHANNELS } from 'components/Promos/Banner';
import withLanding from '../../Landing/withLanding';
import { pages as PAGES } from '../../Landing/constants';
import ProductShowcase from '../ProductShowcase';
import BrandStory from '../BrandStory';
import NonDeliveryOptions from '../NonDeliveryOptions';
import styles from './resi.scss';

const CONTENT_KEYS = {
  hero: 'Hero',
  flow: 'Delivery Flow',
  showcase: 'Products Showcase',
  story: 'Brand Story',
  options: 'Non Delivery Options',
  leads: 'Leads',
};

const Residential = ({ content }) => (
  <div className={styles.resi}>
    <PromoBanner channel={CHANNELS.acq} />
    <Hero content={content.hero} />
    <DeliveryFlow content={content.flow} className={styles.deliveryFlow} />
    <Gulch />
    <ProductShowcase content={content.showcase} />
    <BrandStory content={content.story} />
    <NonDeliveryOptions content={content.options} />
  </div>
);

export default compose(
  withLanding(PAGES.home),
  withContent(CONTENT_KEYS),
)(Residential);
